// extracted by mini-css-extract-plugin
module.exports = {"trigger":"AdvertiserDisclosure_trigger__9FZmQ","trigger-with-background":"AdvertiserDisclosure_trigger-with-background__vxbaF"};